import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M6.736 2v2.105H4.63v4.21a4.21 4.21 0 0 0 4.21 4.211 4.21 4.21 0 0 0 4.211-4.21v-4.21h-2.105V2h3.158c.581 0 1.053.472 1.053 1.053v5.263a6.32 6.32 0 0 1-5.264 6.228v1.666a3.684 3.684 0 0 0 7.132 1.303 3.158 3.158 0 1 1 2.157.156A5.789 5.789 0 0 1 7.788 16.21v-1.667a6.32 6.32 0 0 1-5.263-6.228V3.053C2.525 2.472 2.997 2 3.578 2zm11.578 11.579a1.053 1.053 0 1 0 .001 2.106 1.053 1.053 0 0 0 0-2.106"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }